<template>
    <div class="page-item-info-sizes" v-if="sizes.length">
        <div class="page-item-info-sizes__anchor"
            id="page-item-info-sizes"
        />
        <div class="page-item-info-sizes__content">
            <div class="page-item-info-sizes__content-top">
                <div class="page-item-info-sizes__content-title">
                    <div class="page-item-info-sizes__content-title-link"
                         v-text="`${item.title} В ДРУГИХ РАЗМЕРАХ`"
                    />
                </div>
                <div class="page-item-info-sizes__content-description"
                     v-text="description"
                />
            </div>
            <a v-text="'Как выбрать размер' + ' ↗\uFE0E'"
               v-bind:href="chooseGuide"
               target="_blank"
            />
        </div>
        <div class="page-item-info-sizes__images">
            <template v-if="image1">
                <a class="page-item-info-sizes__images-item"
                   v-bind:style="{ backgroundImage: `url(${image1})` }"
                   v-bind:href="sizes[0].url"
                />
                <div class="page-item-info-sizes__images-item-caption">Размер {{ sizes[0].size }}</div>
            </template>
            <template v-if="image2">
                <a class="page-item-info-sizes__images-item"
                   v-bind:style="{ backgroundImage: `url(${image2})` }"
                   v-bind:href="sizes[1].url"
                   v-if="image2"
                />
                <div class="page-item-info-sizes__images-item-caption _secondary">Размер {{ sizes[1].size }}</div>
            </template>
            <template v-else>
                <div class="page-item-info-sizes__images-item-empty">
                    <common-diagonal-placeholder />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
// import utils from '~/utils';
import config from '~/config';

export default {
    name: 'page-item-info-sizes',
    props: {
        item: {
            type: Object,
        },
        sizes: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        description() {
            return 'S, M и L — классические модели ПАЙ в разных размерах';
        },
        image1() {
            return this.sizes?.[0]?.image ?? null;
        },
        image2() {
            return this.sizes?.[1]?.image ?? null;
        },
        chooseGuide() {
            return config.urls.chooseGuide;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-item-info-sizes {
    position: relative;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    &__anchor {
        display: block;
        position: absolute;
        top: -64px;
    }
    &__content {
        display: flex;
        flex-direction: column;

        flex: 0 0 auto;
        width: 33.33%;
        padding: 16px;
        &-top {
            flex: 1;
        }
        &-title {
            .typography-display-md();

            margin-bottom: 36px;

            text-transform: uppercase;
        }
        &-description {
            .typography-display-md();

            margin-bottom: 24px;
        }
    }
    &__images {
        position: relative;
        flex: 1 1 100%;
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        &-item {
            width: 50%;
            padding-top: 61.25%;
            border-left: 1px solid @color-gray-lightest;

            background-position: center;
            background-size: cover;
        }
        &-item-caption {
            position: absolute;
            left: 16px;
            bottom: 16px;
            &._secondary {
                left: 50%;
                transform: translateX(16px);
            }
        }
        &-item-empty {
            width: 50%;
            border-left: 1px solid @color-gray-lightest;
        }
    }
    @media @media-lg-down {
        &__content {
            flex: 0 0 auto;
            width: 33.33%;
            padding: 16px;
            &-title {
                .typography-display-sm();

                margin-bottom: 28px;
            }
            &-description {
                .typography-display-sm();

                margin-bottom: 16px;
            }
        }
    }
    @media @media-md-down {
        flex-direction: column-reverse;
        &__anchor {
            top: -104px;
        }
        &__content {
            width: 100%;
            border-top: 1px solid @color-gray-lightest;
            &-description {
                max-width: 335px;
            }
        }
        &__images {
        }
    }
}
</style>
